import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { ThreeFieldReflection } from '../interactions/ThreeFieldReflection.jsx'

// Semantic token colours (spec: design says moss/rust/olive)
const SSC_FIELDS = [
  { key: 'start',    label: 'start',    color: 'var(--moss-500)' },
  { key: 'stop',     label: 'stop',     color: 'var(--rust-500)' },
  { key: 'continue', label: 'cont',     color: 'var(--olive-500)' },
]

/**
 * SSCCard — Start / Stop / Continue three-field reflection.
 * catalog #15, prep-ssc. Tightest existing match. Retinted to semantic tokens.
 */
export function SSCCard({ card, value, onChange, disabled }) {
  const hasFill = SSC_FIELDS.some((f) => value?.[f.key])

  return (
    <CardFrame
      kind="prep"
      icon="↺"
      iconClass="olive"
      title="Start / stop / continue"
      prompt="What would you change about your habits?"
      state={disabled ? 'locked' : hasFill ? 'filled' : 'empty'}
      data-testid="prep-card-prep-ssc"
      className="prepcard"
    >
      <ThreeFieldReflection
        fields={SSC_FIELDS}
        values={value ?? {}}
        onChange={onChange}
        maxChars={100}
        disabled={disabled}
      />
    </CardFrame>
  )
}
